import script from "./apply-school-dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./apply-school-dialog.vue?vue&type=script&setup=true&lang=js"

import "./apply-school-dialog.vue?vue&type=style&index=0&id=246d2e34&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-246d2e34"]])

export default __exports__